<script>
  import { collection, getDocs } from 'firebase/firestore'
  import dayjs from 'dayjs'
  import { getContext } from 'svelte'
  import { Datatable } from 'svelte-simple-datatables'
  import { pagesTexts } from '../helpers/pagesTexts'
  import { fixedHeight } from '../helpers/fixedHeight'
  import { subscribe } from '../../helpers/subscribe'
	import Container from '../components/Container.svelte'
  import PageTitle from '../components/PageTitle.svelte'
	import Block from '../components/Block.svelte'
	// import Button from '../components/Button.svelte'
  import Loader, { LoaderHandler } from '../components/Loader.svelte'
  import { ModalHandler } from '../components/Modal.svelte'
  import ItemsDetails from './ItemsDetails.svelte'

  export let authStore, tableRows, snackBarHandler, createdDateThead
  export let currentPage = window.location.pathname.split('/')[2]
  let db = getContext('db')

  export let loaderHandler = new LoaderHandler()
  export let loaderStore = loaderHandler.store()
  export let tableSettings = {columnFilter: false}
  let tableDataModel = {
    data: {
      items: []
    }
  }
  export let tableDataStore = subscribe()
  tableDataStore.set(tableDataModel.data)

  async function pageItemsLoad(valid) {
    if (!valid) return
    loaderHandler.init()
    const itemsSnapshot = await getDocs(collection(db, currentPage))
    let tableData = {
      data: {
        items: []
      }
    }
    if (itemsSnapshot.docs.length == 0) {
      tableDataStore.set(tableData.data)
      if (modalHandler.data.open) modalHandler.action()
      setTimeout(function() {
        loaderHandler.end()
      }, 200)
      return
    }
    let i = 0
    itemsSnapshot.forEach((doc) => {
      i++
      tableData.data.items.push({
        currentPage,
        nome: doc.data().nome,
        instagram: doc.data().instagram,
        email: doc.data().email,
        celular: doc.data().celular,
        nascimentoDisplay: new Date(dayjs(doc.data().nascimento).format('YYYY-MM-DDTHH:mm:ss')).toLocaleDateString('default', {year: 'numeric', month: 'numeric', day: 'numeric'}),
        nascimentoValue: dayjs(doc.data().nascimento).format('YYYY-MM-DDTHH:mm:ss'),
        nascimentoRaw: doc.data().nascimento,
        dateDisplay: new Date(dayjs(doc.data().created_date.toDate()).format('YYYY-MM-DDTHH:mm:ss')).toLocaleDateString('default', {year: 'numeric', month: 'numeric', day: 'numeric'}),
        dateValue: dayjs(doc.data().created_date.toDate()).format('YYYY-MM-DDTHH:mm:ss'),
        created_date: doc.data().created_date.toDate(),
        id: doc.id,
        autorizo_coleta_dados: doc.data().autorizo_coleta_dados,
        aceito_regulamento_e_politica: doc.data().aceito_regulamento_e_politica,
        cep: doc.data().cep,
        endereco: doc.data().endereco,
        numero: doc.data().numero,
        complemento: doc.data().complemento,
        bairro: doc.data().bairro,
        estado: doc.data().estado,
        cidade: doc.data().cidade,
      })
      if (i == itemsSnapshot.docs.length) {
        tableDataStore.set(tableData.data)
        setTimeout(function() {
          createdDateThead.click()
          setTimeout(function() {
            loaderHandler.end()
            if (modalHandler.data.open) modalHandler.action()
          }, 200)
        }, 100)
      }
    })
  }
  pageItemsLoad(true)

  export let modalHandler = new ModalHandler()
  let dataModelModal = {
    data: {
      currentPage,
      title: pagesTexts[currentPage].newModalTitle,
      subtitle: pagesTexts[currentPage].newModalSubtitle
    }
  }
  export let modalDataStore = subscribe()
  modalDataStore.set(dataModelModal.data)

  function modalToggle(id) {
    return function() {
      if (id) {
        let index = $tableDataStore.items.findIndex((row) => row.id == id)
        let rowData = {
          data: {...{
            title: pagesTexts[currentPage].detailsModalTitle,
            subtitle: pagesTexts[currentPage].detailsModalSubtitle
          }, ...$tableDataStore.items[index]}
        }
        modalDataStore.set(rowData.data)
      } else {
        let newData = {
          data: {...dataModelModal.data, ...{
            
          }}
        }
        modalDataStore.set(newData.data)
      }
      modalHandler.action()
    }
  }
</script>

<Container spacing=24>
  <PageTitle
		title={pagesTexts[currentPage].pageTitle}
		subtitle={pagesTexts[currentPage].pageSubtitle}
	/>
  <!-- <Block l=100 style="display: flex; justify-content: flex-end;">
    <Button
      text={pagesTexts[currentPage].newItemBtn}
      type="button"
      classes="secondary small"
      onclick={modalToggle(null)}
    />
  </Block> -->
  <Block l=100>
    <div class="content-height-table-top-button" style="position: relative;" use:fixedHeight>
      <Loader
        store={loaderStore}
        classes="content-height-table-top-button"
      />
      {#if $tableDataStore.items.length > 0}
        <Datatable
          data={$tableDataStore.items}
          settings={tableSettings}
          bind:dataRows={tableRows}
        >
          <thead class="case_1">
            <th data-key="nome">Nome completo</th>
            <th data-key="email">Email</th>
            <th data-key="(row) => row.nascimentoValue">Nascimento</th>
            <th class="asc" data-key="(row) => row.dateValue" bind:this={createdDateThead}>Cadastro</th>
            <th data-key="autorizo_coleta_dados">Autoriza Dados</th>
            <th></th>
          </thead>
          <tbody class="case_1">
            {#if $tableRows}
              {#each $tableRows as row}
                <tr class="link_items" on:click={modalToggle(row.id)}>
                  <td title={row.nome}>{row.nome}</td>
                  <td title={row.email}>{row.email}</td>
                  <td>{row.nascimentoDisplay}</td>
                  <td>{row.dateDisplay}</td>
                  <td>{row.autorizo_coleta_dados == '1' ? 'Sim' : 'Não'}</td>
                  <td>
                    <span class="link">Detalhes</span>
                  </td>
                </tr>
              {/each}
            {/if}
          </tbody>
        </Datatable>
      {:else}
        <div class="empty-msg">
          <ion-icon name="file-tray-outline"></ion-icon>
          <p class="subtitle">
            Nenhum item cadastrado.
          </p>
        </div>
      {/if}
    </div>
  </Block>
</Container>

<ItemsDetails
  {authStore}
  {modalHandler}
  {modalDataStore}
  {snackBarHandler}
  formCallback={pageItemsLoad}
/>

<style lang="scss">
  .link_items td {
    cursor: pointer !important;
  }
  .empty-msg {
    padding-top: 60px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    p {
      width: 100%;
      text-align: center;
    }
    ion-icon {
      display: block;
      width: 200px;
      opacity: .25;
    }
  }
</style>